import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useLocation} from 'react-router';
import {getLocale} from '../../i18n/helper';
import {pushRoute} from '../../routes';

const SetLocale: React.FC = () => {
  const dispatch = useDispatch();
  const locationUrl = useLocation();
  const currentLang = getLocale();

  useEffect(() => {
    const actualLang = locationUrl.pathname.replace('/', '');

    if (currentLang === actualLang) {
      dispatch(pushRoute('welcome'));
      return;
    }

    switch (actualLang) {
      case 'en':
        setLocale('en');
        break;
      case 'es':
        setLocale('es');
        break;
      default:
      case 'pt':
        setLocale('pt');
        break;
    }
  }, [location]);

  const setLocale = (lang: string) => {
    window.localStorage.setItem('SEI_POCKET_LOCALE', lang);
    location.reload();
  };

  return <></>;
};

export default SetLocale;



// WEBPACK FOOTER //
// ./src/features/election/SetLocale.tsx